import { Card } from "../../../components/Card";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../services/api";
import { ReactComponent as StarIcon } from "../../../assets/icons/star.svg";
import { TrendIndicator } from "../../../components/TrendIndicator";
import { getNumberSuffix } from "../../../services/utils";
import { Rating } from "../../praxis-call/components/Rating";
import { twMerge } from "tailwind-merge";

const ScoreCard = ({ title, trendInfo, textClassName, showRating = false, showStar = true, score, showTrend = true, isTeamStanding = false }: { title: string, score: number | string, showRating?: boolean, showStar?: boolean, showTrend?: boolean, trendInfo?: any, isTeamStanding?: boolean, textClassName?: string }) => {
  return (
    <Card className="flex-1 flex flex-col gap-5 !p-[18px]">
      <div className="text-[clamp(13px,1.5vw,16px)] font-semibold text-text-primary">{title}</div>

      <div className="flex items-center gap-2.5">
        {showRating ? <Rating contentClassName="!ml-0" halfStarClassName={Number(score) < 1 ? "!-ml-1" : ""} showRemainingStars={true} value={Number(score)} showMax={false} showCount={false} /> : showStar ? <StarIcon className="w-5 h-5" /> : null}
        <span className={twMerge("text-[#343434] font-normal !text-[clamp(11px,1.5vw,13px)]", textClassName)}>{score} {isTeamStanding ? "Place" : ""}</span>
      </div>

      {showTrend && (
        <TrendIndicator
          trendInfo={trendInfo}
          denominator={isTeamStanding ? "places" : "percent"}
          textClassName="text-[#969696] !text-[clamp(11px,1.5vw,13px)]"
        />
      )}
    </Card>
  )
}

export function PerformanceAnalytics() {
  const {
    data: praxisScores,
    isLoading: isLoadingPraxisScores,
    refetch: refetchPraxisScores,
  } = useQuery({
    queryKey: ["praxis-scores"],
    queryFn: () => api.getPraxisScores(),
    refetchOnWindowFocus: false,
  });

  const scores = praxisScores?.data || {};

  return (
    <div className="flex flex-col gap-[18px] h-full w-full">
      <div className="flex gap-[18px] flex-1">
        <ScoreCard showRating={true} textClassName="!text-[clamp(15px,1.5vw,18px)]" title="Last Session Score" score={scores?.lastPraxisScore} showTrend={false} />
        <ScoreCard showRating={true} textClassName="!text-[clamp(15px,1.5vw,18px)]" title="Avg. Session Score" score={scores?.averagePraxisScore} trendInfo={scores?.averagePraxisScoreTrend} />
      </div>
      <div className="flex gap-4 flex-1">
        <ScoreCard title="Team Standing" showStar={false} isTeamStanding score={scores?.teamPosition ? `${scores?.teamPosition}${getNumberSuffix(scores?.teamPosition)}` : "-"} trendInfo={scores?.teamPositionTrend} />
        <ScoreCard title="Time Per Session" showStar={false} score={`${((scores?.averageDuration || 0) / 60).toFixed(0)} mins`} trendInfo={scores?.averageDurationTrend} />
      </div>
    </div>
  )
}
